import { render } from "./NewsDialog.vue?vue&type=template&id=15dd80e4&scoped=true"
import script from "./NewsDialog.vue?vue&type=script&lang=js"
export * from "./NewsDialog.vue?vue&type=script&lang=js"

import "./NewsDialog.vue?vue&type=style&index=0&id=15dd80e4&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15dd80e4"]])

export default __exports__